<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">
                Customized Translation <br />Service for Professionals
              </h1>
              <p class="text-lead text-white">
                You can dramatically reduce the translation time <br />by using
                the fast and accurate AI translator <br />through the services.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div
            :class="{ 'social-user-card': socialUser }"
            class="card bg-secondary border-0 mb-0"
          >
            <div class="card-body px-lg-5 pt-lg-5 pb-0">
              <div class="text-center text-muted mb-4">
                <small v-if="state === 'verify'">
                  Resend verification email
                </small>
                <small v-if="state === 'social'" class="social-user">
                  Link existing ID
                </small>
                <small v-if="state === 'idle'">ID/PASSWORD Login</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    v-if="state === 'verify'"
                    alternative
                    class="mb-3"
                    prepend-icon="ni ni-email-83"
                    name="Email"
                    readonly
                    v-model="email"
                  ></base-input>
                  <base-input
                    v-if="['idle', 'social'].includes(state)"
                    id="login-id"
                    alternative
                    class="mb-3"
                    prepend-icon="fas fa-id-badge"
                    placeholder="ID or Email"
                    name="ID"
                    rules="required"
                    v-model="model.id"
                  >
                  </base-input>

                  <base-input
                    v-if="['idle', 'social'].includes(state)"
                    id="login-pw"
                    alternative
                    class="mb-3"
                    name="Password"
                    rules="required"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                    v-model="model.pw"
                  >
                  </base-input>

                  <base-checkbox
                    v-if="state === 'idle'"
                    v-model="model.remember_me"
                  >
                    Save login
                  </base-checkbox>
                  <div class="text-center">
                    <base-button
                      id="login-button"
                      type="primary"
                      native-type="submit"
                      class="my-4"
                    >
                      {{ submitText }}
                    </base-button>
                  </div>
                  <!-- <base-alert v-if="message" dismissible type="warning">
                    {{ message }}
                  </base-alert> -->
                  <div
                    class="invalid-feedback text-center"
                    style="display: block;"
                  >
                    {{ message }}
                  </div>
                </form>
              </validation-observer>
            </div>
            <hr v-if="state === 'idle' && !isPackage" class="mx-3 my-3" />
            <div
              class="google-btn"
              v-if="state === 'idle' && !isPackage"
              @click="signInWithGoogle"
            >
              <div class="google-icon-wrapper">
                <img class="google-icon-svg" src="/img/google-logo.svg" />
              </div>
              <p class="btn-text"><b>Login with Google</b></p>
            </div>
            <div
              class="text-center"
              v-else-if="isPackage"
            >
              <base-button
                id="login-button"
                type="primary"
                native-type="submit"
                class="my-4"
              >
                <router-link to="/" class="text-white">
                  SSO Login
                </router-link>
              </base-button>
            </div>
          </div>
          <div class="row mt-3" v-if="!isPackage">
            <div class="col-6">
              <router-link
                v-if="state === 'idle'"
                to="/reset-password"
                class="text-light"
              >
                <small>Forgot your password?</small>
              </router-link>
            </div>
            <div class="col-6 text-right">
              <div class="text-light register-button" @click="gotoRegister">
                <small>Register</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
export default {
  data() {
    return {
      model: {
        id: '',
        pw: '',
        remember_me: true,
      },
      email: '',
      message: '',
      errorCount: 0,
    }
  },
  computed: {
    ...mapState(['socialUser']),
    ...mapGetters(['isEmailVerified', 'isActive', 'isPackage', 'isTwoFactor']),
    state() {
      if (this.$route.hash.includes('verify')) return 'verify'
      if (this.socialUser) return 'social'
      // if (this.isPackage) return 'package'
      return 'idle'
    },
    submitText() {
      if (this.state === 'verify') return 'Resend verification mail'
      if (this.state === 'social') return 'Link my ID'
      return 'Login'
    },
  },
  methods: {
    async onSubmit() {
      try {
        this.message = ''
        if (this.state === 'idle') {
          await this.$store.dispatch('login', this.model)
          await this.onLoginWithoutVerifaction()
        } else if (this.state === 'verify') {
          await this.resendVerificationEmail()
        }
      } catch (error) {
        this.onError(error)
      }
    },
    onError(error) {
      if (error.response) {
        this.errorCount++
        if (this.errorCount % 5 === 0) {
          this.$swal.fire({
            title: 'Forgot your password?',
            autoClose: true,
            html: `<div><img src="/img/forgotpassword.png" width="350px"/></div>`,
          })
        }
        this.message = error.response.data.message
      } else {
        this.message = error.message
      }
    },
    async gotoRegister() {
      if (this.socialUser) {
        await this.$store.commit('saveSocialUser', false)
      }
      await this.$router.push('/register')
    },
    async resendVerificationEmail() {
      await this.$slowbro.post('/me/verify/email/send', {
        email: this.email,
      })
      await this.$swal.fire({
        message:
          'Confirmation e-mail has been sent. Please check your e-mail to complete your signup',
      })
    },
    async signInWithGoogle() {
      try {
        this.message = ''
        const socialUser = await this.$gAuth.signIn()
        await this.$store
          .dispatch('login', {
            id_token: socialUser.getAuthResponse().id_token,
            remember_me: this.model.remember_me,
          })
          .then(() => this.onLoginWithoutVerifaction())
          .catch(e => {
            this.$store.commit('saveSocialUser', socialUser)
            this.$router.push('/login#social')
          })
      } catch (error) {
        this.onError(error)
      }
    },
    async onLoginWithoutVerifaction() {
      if (this.isTwoFactor) {
        await this.$router.push('/two-factor-verification')
        return
      }
      if (!this.isActive) {
        await this.$swal.fire({
          html: `This account has been deactivated. Please contact us via chatbot or <a href="mailto:support@ailinggo.ai">support@ailinggo.ai</a>.`,
        })
        await this.$store.dispatch('logout')
        return
      }
      if (this.isEmailVerified) {
        this.onLoginWithVerfication()
      } else {
        this.requireVerification()
      }
    },
    async onLoginWithVerfication() {
      if (this.socialUser) {
        const profile = this.socialUser.getBasicProfile()
        await this.$store.dispatch('updateProfile', {
          third_party: profile.getEmail(),
          pw: this.model.pw,
        })
      }
      await this.$router.push('/')
    },
    async requireVerification() {
      await this.$swal.fire({
        message: 'Your email has not been verified',
      })
      this.email = this.$store.state.email
      this.$router.push('/login#verify')
    },
  },
  watch: {
    $route() {
      if (this.$route.hash !== '#social') {
        this.$store.commit('saveSocialUser', null)
      }
    },
  },
}
</script>
<style scoped lang="scss">
.register-button {
  cursor: pointer;
}
.social-user {
  color: #131f3c;
  font-size: 16px;
  font-weight: bold;
}
.social-user-card {
  background-color: #dee1e3 !important;
}

.google-btn {
  margin-bottom: 25px;
  width: 100%;
  min-width: 232px;
  max-width: 232px;
  height: 52px;
  background-color: #fcfcfc;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
  cursor: hand;
  align-self: center;
  user-select: none;
  transition: all 400ms ease 0s;
  display: flex;
}
.google-btn .google-icon-wrapper {
  position: absolute;
  margin-top: 1px;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  user-select: none;
}
.google-btn .google-icon-svg {
  position: relative;
  margin-top: 14px;
  margin-left: 14px;
  width: 24px;
  height: 24px;
  user-select: none;
}
.google-btn .btn-text {
  float: right;
  margin: 14px 14px 40px 60px;
  color: #757575;
  font-size: 18px;
  letter-spacing: 0.2px;
  font-family: Roboto;
  user-select: none;
}
.google-btn:hover {
  box-shadow: 0 3px 8px rgba(117, 117, 117, 0.5);
  user-select: none;
}
.google-btn:active {
  box-shadow: 0 1px 1px #757575;
  background: #f8f8f8;
  color: #fff;
  user-select: none;
}
</style>
